
import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

// CompareImgs
import ReactCompareImage from 'react-compare-image';

// StagesCarousel
import StagesCarousel from '../index/News/StagesCarousel.js';

// core components
import { SRLWrapper } from "simple-react-lightbox";

function News() {

  // Create an object with the options that you want to use. The options are divided in 4 main objects. You don't need to define them all.
  const options = {
    settings: {
      overlayColor: "rgb(0, 0, 0, 0.9)",
    },
  };

  return (
    <>
      <div className="section section-dark section-nucleo-icons" >
        <Container>
          <Row>
            <Col md="6" style={{ textAlign: 'right', paddingRight: '3%', paddingLeft: '15px' }} className="gradient-right" >
              <h2 className="title">Remastered Sprites</h2>
              <hr style={{ clear: 'both' }} />
              <p className="description">
                Probably the biggest challenge for the game. Now each char sprite of the Season 2 Final has
                been remastered giving a much sharper appearance and making them be in context with the artistic aspect of the stages.
               </p>
              <br />
              <br />
            </Col>
            <Col md="6" className="gradient-left" style={{ paddingLeft: '0px' }}>
              <ReactCompareImage
                className="img-rounded img-responsive"
                leftImage={require("assets/img/Index/Rem_Char-16-9.png")}
                rightImage={require("assets/img/Index/Rem_Char-16-9-Pixel.png")}
              />
            </Col>
          </Row>
        </Container>
        <SRLWrapper options={options}>
          <Container>
            <Row>
              <Col md="6" className="gradient-right" style={{ paddingRight: '0px' }} >
                <StagesCarousel
                  className="img-rounded img-responsive"
                />
              </Col>
              <Col md="6" style={{ textAlign: 'left', paddingLeft: '3%', paddingRight: '15px' }} className="gradient-left">
                <h2 className="title">Spectacular Stages</h2>
                <hr style={{ clear: 'both' }} />
                <p className="description">
                  One of the most important points to highlight in every MKDOTE release are the new stages that the game offers.
                  Now, each stage was improved and optimized, giving a much sharper and more immersive quality.
                </p>
                <br />
                <br />
              </Col>
            </Row>
          </Container>
          <Container>
            <Row>
              <Col md="6" style={{ textAlign: 'right', paddingRight: '3%', paddingLeft: '15px' }} className="gradient-right" >
                <h2 className="title">Cinematic Camera</h2>
                <hr style={{ clear: 'both' }} />
                <p className="description">
                  Always keeping in motion and in context with what is happening on the screen, the camera now has a slight movement effect,
                  with added zoom and less sensitivity to combos, bumps and drops.
                </p>
                <br />
                <br />
              </Col>
              <Col md="6" className="gradient-left" style={{ paddingLeft: '0px' }} >
                <div className="embed-responsive embed-responsive-16by9">
                  <video muted autoPlay={true} loop={1} title="intro" className="embed-responsive-item" src={require("assets/videos/camara.webm")} type="video/webm" ></video>
                </div>
              </Col>
            </Row>
          </Container>
          <Container>
            <Row>
              <Col md="6" className="gradient-right" style={{ paddingRight: '0px' }} >
                <img
                  style={{ cursor: 'pointer' }}
                  alt="Select Screen"
                  className="img-rounded img-responsive"
                  src={require("assets/img/Index/UI_Select_Screen.jpg")}
                />
              </Col>
              <Col md="6" style={{ textAlign: 'left', paddingLeft: '3%', paddingRight: '15px' }} className="gradient-left" >
                <h2 className="title">Beautiful User Interface</h2>
                <hr style={{ clear: 'both' }} />
                <p className="description">
                  Menu, Select Screen, Fonts, Towers (Choose Your Destiny), Vs, Move List, Life Bars and any interface
                  that the user needs to access are now in HD with a modern and clean style.
                    </p>
                <br />
                <br />
              </Col>
            </Row>
          </Container>
        </SRLWrapper>
      </div>{" "}
    </>
  );
}

export default News;
